// ---------------------------------------------------------------------------
// Shared Meta Pixel ID — keep in sync with the base pixel snippet in
// public/index.html (`fbq('init', '<id>')`).
//
// Used by components that fire conversion events with Advanced Matching
// (email/name) so fbq('init', ...) can be re-called with customer data
// right before the event fires. Meta's pixel SDK hashes plain-text
// values client-side before sending — do not pre-hash these.
// ---------------------------------------------------------------------------

export const META_PIXEL_ID = "3563620700399809";
